import React from 'react';

const Pinned = ({
  cb = () => {},
  tag = 'span',
  offsetX = 0,
  offsetY = 0,
  isCenteredX = false,
  isCenteredY = false,
  isCentered = true,
  elevation = 9,
  ...props
}) => {
  const Tag = tag;

  const commonStyles = {
    position: 'absolute',
    zIndex: elevation ? elevation : 9,
    maxWidth: '100%',
  };

  function variantStyles() {
    if (isCenteredX)
      return {
        left: '50%',
        transform: `translate(-50%, ${offsetY})`,
      };
    else if (isCenteredY) {
      return {
        top: '50%',
        transform: `translate(${offsetX}, -50%)`,
      };
    } else {
      return {
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
      };
    }
  }

  return (
    <Tag
      {...props}
      style={{ ...commonStyles, ...variantStyles() }}
      onClick={() => cb()}
    >
      {props.children}
    </Tag>
  );
};

export default Pinned;
